// ==============================================================================
// Imports
// ==============================================================================

import validator from "validator";
import { store } from "../../store";
import { clearErrorMessage, displayWarningMessage } from "../marvel-reducers/formMessageActions";

// ==============================================================================
// Input Validations
// ==============================================================================
let message = [];
let warning = false;

const reqInput = (input, field) => {
    if (input !== "" && input !== null && typeof input !== 'undefined') {
        return true
    } else {
        message.push(`Please provide valid Input for ${field}`);
        warning = true;
    }
};

const isEmail = (email, field) => {
    if (email === "" || email === null || validator.isEmail(email)) {
        return true
    } else {
        message.push(`Please provide a valid Email Address for the ${field}`);
        warning = true;
    }
};

// const isPhone = (phoneNumber, field) => {
//   if (validator.isMobilePhone(phoneNumber) || phoneNumber === "") {
//     return true
//   } else {
//     message.push(`Please provide a valid Phone Number for the ${field}`);
//     warning = true;
//     store.dispatch(displayWarningMessage(message, warning));
//   }
// };

const isInt = (input, field) => {
    input = input !== null ? input.toString() : '';
    if (validator.isInt(input)) {
        return true
    } else {
        message.push(`Please provide a valid Integer for ${field}`);
        warning = true;
    }
};

const isUrl = (url, field) => {
    if (url === "" || url === null || validator.isURL(url, { protocols: ['http', 'https'], require_protocol: true })) {
        return true
    } else {
        message.push(`Please provide a valid url for ${field}`);
        warning = true;
    }
};
// eslint-disable-next-line no-unused-vars
const isDate = (date, field) => {
    if (date === null || validator.isISO8601(date) || date === "" || date === "0000-00-00") {
        return true
    } else {
        message.push(`Please provide a valid Date for ${field}`);
        warning = true;
    }
};

const isFloat = (float, field) => {
    if (float === "" || float === null) {
        return true
    }
    float = float.toString();
    if (validator.isFloat(float)) {
        return true
    } else {
        message.push(`Please enter a valid Number for ${field}`);
        warning = true;
    }
};

// custom check only used by validation on manual entry billing records
const isCountryRequired = (billingType, billingProduct) => {
    if (billingType === 'INVOICE' &&
        (billingProduct === "AVS" || billingProduct === "IDV" || billingProduct === "BV")) {
        return true;
    }
}

const isValidServiceType = (serviceType) => {
    if (serviceType === "kyb" || serviceType === "kyc") {
        return true
    } else {
        message.push(`Please enter a valid Service Type, either KYC or KYB.`);
        warning = true;
    }
}

const isValidSubDPType = (serviceType, subDPType) => {
    // allow this check if dp-type is KYC and in that case sub-dp-type will default to null.
    if (subDPType === null || serviceType === "kyc" || subDPType === "bv" || subDPType === "bv+"
        || subDPType === "odo" || subDPType === "kyb") {
        return true
    } else {
        message.push(`Please enter a valid Sub-DP Type from the Options.`);
        warning = true;
    }
}

const hasPrimaryServiceConfigName = (serviceObject) => {

    if (serviceObject.service_config_names.length > 0) {
        if (serviceObject.service_config_names.some(e => e.is_primary)) {
            return true;
        }
        else {
            message.push(`Please Mark Is Primary for One the Associated Service Config Names.`);
            warning = true;
        }
    } else {
        message.push(`Please Select at least one Service Config Name `);
        warning = true;
    }
}

const isConsentRequired = (dpSourceObj) => {
    if (dpSourceObj.consent_required) {
        return true
    } else if (dpSourceObj.contractual_passthrough || dpSourceObj.passthrough_sample !== null) {

        message.push(
            `You have set Consent Required to "No", but have included additional consent information under
            Passthrough Sample. Either set Consent Required and Contractual Passthrough to "Yes" or remove the
            additional consent information.`
        );
        warning = true;
    } else if (dpSourceObj.consent_flag_required || dpSourceObj.flag_required_sample !== null) {

        message.push(
            `You have set Consent Required to "No", but have included additional consent information under
            Flag Required Sample. Either set Consent Required and Consent Flag to "Yes" or remove the
            additional consent information.`
        );
        warning = true;
    } else {
        return true
    }
}

const isValidPricingJson = (pricingJson) => {
    let isValid = true;
    let prevPrice;
    if (pricingJson.length > 0) {
        // defaulting price of the first tier as the max.
        prevPrice = pricingJson[0].price;
        pricingJson.forEach(p => {
            if (p.max !== null && p.min > p.max) {
                message.push(`Discrepancy found in Tier Values. Please ensure the value for Min. is less than Max.`);
                warning = true;
                isValid = false;
            }
            if (p.price > prevPrice) {
                message.push(`Discrepancy found in Price Values. Please ensure the prices are decreasing with every
                new tier that is added. ${p.price} > ${prevPrice}`);
                warning = true;
                isValid = false;
            }
            if (p.price === 0) {
                message.push(`Please enter a non-zero value for price.`);
                warning = true;
                isValid = false;
            }
            prevPrice = p.price;
        });
        return isValid;
    } else {
        message.push(`Please enter the right value for price of the country.`);
        warning = true;
    }
}

export function validateDPForm(providerObj) {

    clearMessages();
    const validateInput = reqInput(providerObj.provider_detail.provider_name, "Provider Name");
    const validateTechnicalEmail = isEmail(providerObj.contact_information[0].email, "Technical Contact Email");
    const validateBusinessEmail = isEmail(providerObj.contact_information[1].email, "Business Contact Email");

    if (validateInput && validateTechnicalEmail && validateBusinessEmail) {
        return true
    } else {
        store.dispatch(displayWarningMessage(message, warning));
    }

}

export function validateDPServiceForm(serviceObj) {

    clearMessages();
    const validateServiceName = reqInput(serviceObj.service_detail.service_name, "Service Name");
    const validateProvider = reqInput(serviceObj.service_detail.provider, "Data Provider");
    const validateBillingGroup = reqInput(serviceObj.service_detail.billing_group_id, "Billing Group");
    const validDPType = isValidServiceType(serviceObj.service_detail.dp_type);
    const validSubDPType = isValidSubDPType(serviceObj.service_detail.dp_type, serviceObj.service_detail.sub_type);
    const validatePrimaryServiceConfigName = hasPrimaryServiceConfigName(serviceObj);
    // not sure whether email has to be validated at this point.
    // const validateEmail = isEmail(serviceObj.contact_info.email, "Technical Contact Email");

    if (
        validateServiceName && validDPType && validSubDPType &&
        validateProvider && validateBillingGroup && validatePrimaryServiceConfigName
    ) {
        return true
    } else {
        store.dispatch(displayWarningMessage(message, warning));
    }
}

export function validateDocLinks(docObj) {
    const techURL = isUrl(docObj.technical, "Technical Documentation Link");
    if (techURL) {
        return true
    }
}

export function validateSourceForm(sourceObj) {

    const validateSourceType = reqInput(sourceObj.source_detail.source_type, "Source Type");
    const validateServiceName = reqInput(sourceObj.service.service_name, "Service Name");
    const validateCountry = reqInput(sourceObj.country.country_name, "Country Name");
    const validateSourceTypeId = isInt(sourceObj.source_detail.source_type_identifier, "Source Type Identifier");
    const validateResourceURL = isUrl(sourceObj.source_detail.resource_url, "Additional Resources URL");
    const validateOverallCoverage = isFloat(sourceObj.source_detail.overall_coverage, "Overall Coverage %");
    const validateConsentRequired = isConsentRequired(sourceObj.source_detail);

    if (
        validateSourceType && validateServiceName && validateCountry &&
        validateSourceTypeId && validateResourceURL &&
        validateOverallCoverage && validateConsentRequired
    ) {
        return true
    } else {
        store.dispatch(displayWarningMessage(message, warning));
    }
}

export function validatePricingTableForm(pricingTableObject) {

    clearMessages();
    const validateName = reqInput(pricingTableObject.name, "Name");
    const validatePrice = reqInput(pricingTableObject.base_price, "Base Price");

    if (validateName && validatePrice) {
        return true
    } else {
        store.dispatch(displayWarningMessage(message, warning));
    }
}

export function validatePricingTableFormV2(pricingTableObjectV2) {
    clearMessages();
    const validateName = reqInput(pricingTableObjectV2.name, "Name");
    const validateDescription = reqInput(pricingTableObjectV2.description, "Description");
    const validateVolumeAggregationType = reqInput(pricingTableObjectV2.volume_aggregation_type, "Volume Aggregation Type")
    const validateBasePrice = reqInput(pricingTableObjectV2.base_price, "Base Price")

    if (validateName && validateDescription && validateVolumeAggregationType && validateBasePrice) {
        if (pricingTableObjectV2.base_price === 0) {
            message.push(`Please enter a non-zero value for price.`);
            warning = true;
            store.dispatch(displayWarningMessage(message, warning));
            return false;
        } else {
            return true
        }
    } else {
        store.dispatch(displayWarningMessage(message, warning));
    }
}

export function validateCountryPricingForm(countryPriceObject) {

    clearMessages();
    const validatePrice = reqInput(countryPriceObject.price, "Price");
    const validateCountry = reqInput(countryPriceObject.countries, "Countries");

    if (validateCountry && validatePrice) {
        return true
    } else {
        store.dispatch(displayWarningMessage(message, warning));
    }
}

export function validateCountryPricingFormV2(countryPriceObject) {

    clearMessages();
    const validatePricingJson = isValidPricingJson(countryPriceObject.pricing_json);
    const validateCountry = reqInput(countryPriceObject.country_code, "Country");
    const validatePricingScheme = reqInput(countryPriceObject.pricing_scheme, "Pricing Scheme");

    if (validateCountry && validatePricingJson && validatePricingScheme) {
        return true
    } else {
        store.dispatch(displayWarningMessage(message, warning));
    }
}

export function validateBillingOrganizationForm(billingOrgObject) {

    clearMessages();
    const validateOrgName = reqInput(billingOrgObject.orgDetail.name, "Organization Name");
    const validateEmail = isEmail(billingOrgObject.orgDetail.email, "Email");
    const validateMinCo = isFloat(billingOrgObject.orgBilling.monthly_minimum_commitment,
        "Min. Monthly Commitment");
    const validatePlatformFee = isFloat(billingOrgObject.orgBilling.monthly_platform_fee, "Monthly Platform Fee");

    const validateBillingANumber = reqInput(billingOrgObject.orgBilling.billing_a_number, "Billing A Number");
    const validateLocationANumber = reqInput(billingOrgObject.orgBilling.location_a_number, "Location A Number");

    if (validateOrgName && validateEmail && validateMinCo && validatePlatformFee && validateBillingANumber && validateLocationANumber) {
        return true
    } else {
        store.dispatch(displayWarningMessage(message, warning));
    }

}

export function validateNewCPUser(portalPayload) {

    clearMessages();
    const validateEmail = isEmail(portalPayload.email);
    const validateFirstName = reqInput(portalPayload.firstName, "First Name")
    const validateLastName = reqInput(portalPayload.lastName, "Last Name")

    if (validateEmail && validateFirstName && validateLastName) {
        return true;
    } else {
        store.dispatch(displayWarningMessage(message, warning))
    }
}

export function validateNewServiceConfigNameForm(scnObject) {

    const validateServiceConfigName = reqInput(scnObject.serviceConfigName, "Service Config Name");

    if (validateServiceConfigName) {
        return true
    } else {
        store.dispatch(displayWarningMessage(message, warning));
    }
}

export function validateCountryForm(countryObject) {

    const validateCountryName = reqInput(countryObject.country_name, "Country Name");
    const validateKYCStatus = reqInput(countryObject.kyc_status, "KYC Status");
    const validateKYCTier = reqInput(countryObject.kyc_tier, "KYC Tier");
    const validate1x1MR = isInt(countryObject.number_1x1_match_rate, "1x1 MR");
    const validate2x2MR = isInt(countryObject.number_2x2_match_rate, "2x2 MR");

    if (validateCountryName && validateKYCStatus && validateKYCTier &&
        validate1x1MR && validate2x2MR) {
        return true;
    } else {
        store.dispatch(displayWarningMessage(message, warning))
    }

}

export function validateBillingGroupForm(billingGroupObject) {

    const validateBillingGroupName = reqInput(billingGroupObject.billing_group_name, "Billing Group Name");
    const validateInvoiceName = reqInput(billingGroupObject.invoice_name, "Invoice Name");
    const validateContractStartDate = isDate(billingGroupObject.contract_start_date, "Contract Start Date");
    const validateCurrency = reqInput(billingGroupObject.currency, "Currency");
    const validatePriceModel = reqInput(billingGroupObject.price_model, "Price Model");
    const validateBillingPeriod = isInt(billingGroupObject.billing_period, "Billing Period");
    const validateVolumeAggregation = reqInput(billingGroupObject.volume_aggregation_type, "Volume Aggregation Type")
    const validateBasePrice = reqInput(billingGroupObject.base_price, "Base Price")


    if (validateBillingGroupName && validateInvoiceName && validateContractStartDate && validateBasePrice &&
        validateCurrency && validatePriceModel && validateBillingPeriod && validateVolumeAggregation) {
        if (billingGroupObject.base_price === 0) {
            message.push(`Please enter a non-zero base price.`);
            warning = true;
            store.dispatch(displayWarningMessage(message, warning));
            return false;
        } else {
            return true
        }
    } else {
        store.dispatch(displayWarningMessage(message, warning))
    }

}

export function validateBillingGroupServicesForm(billingGroupObject) {

    const validateBillingGroupName = reqInput(billingGroupObject.billing_group_name, "Billing Group Name");
    const validateInvoiceName = reqInput(billingGroupObject.invoice_name, "Invoice Name");

    if (validateBillingGroupName && validateInvoiceName) {
        return true;
    } else {
        store.dispatch(displayWarningMessage(message, warning))
    }

}

/**
 * Validate KYC Testcache Form
 * KYC requires identity fields: completename, givenfullname, surname_first, nationalid, dob, phone
 * Uses /testcache/kyc endpoint
 */
export function validateKYCTestcacheForm(testcacheObject) {

    clearMessages();

    // Validate required fields: Country and Source Type
    const validateCountry = reqInput(testcacheObject.countrycode, "Country Code");
    const validateDST = reqInput(testcacheObject.data_source_type, "Source Type");

    if (!validateCountry || !validateDST) {
        store.dispatch(displayWarningMessage(message, warning));
        return { isValid: false };
    }

    // Check if at least one identity (KYC) specific field is filled
    const hasIdentityFields = testcacheObject.completename || testcacheObject.givenfullname ||
        testcacheObject.surname_first || testcacheObject.nationalid || testcacheObject.dob ||
        testcacheObject.phone;

    if (!hasIdentityFields) {
        message.push(`For Identity (KYC) records, please include at least one name field.`);
        warning = true;
        store.dispatch(displayWarningMessage(message, warning));
        return { isValid: false };
    }

    return { isValid: true };
}

/**
 * Validate KYB Testcache Form
 * Required fields:
 * - Either organization_name OR business_id (at least one)
 * - datasource
 * - countrycode
 * All other fields are optional.
 * Uses /testcache/kyb endpoint
 */
export function validateKYBTestcacheForm(kybTestcacheObject) {

    clearMessages();

    // Check if at least one organization field is provided (organization_name or business_id)
    const hasOrgName = kybTestcacheObject.organization_name && kybTestcacheObject.organization_name.trim() !== "";
    const hasBusinessId = kybTestcacheObject.business_id && kybTestcacheObject.business_id.trim() !== "";

    if (!hasOrgName && !hasBusinessId) {
        message.push(`Please provide either Organization Name or Business ID.`);
        warning = true;
    }

    // Required: Data Source
    const validateDataSource = reqInput(kybTestcacheObject.datasource, "Data Source");

    // Required: Country Code
    const validateCountry = reqInput(kybTestcacheObject.countrycode, "Country Code");

    // Optional: Check country code format if provided (must be exactly 2 characters)
    if (kybTestcacheObject.countrycode && kybTestcacheObject.countrycode.length !== 2) {
        message.push(`Country Code must be exactly 2 characters.`);
        warning = true;
    }

    // Optional: Email format validation if provided
    if (kybTestcacheObject.full_email_address && kybTestcacheObject.full_email_address.trim() !== "") {
        isEmail(kybTestcacheObject.full_email_address, "Email Address");
    }

    if ((hasOrgName || hasBusinessId) && validateDataSource && validateCountry && !warning) {
        return { isValid: true };
    } else {
        store.dispatch(displayWarningMessage(message, warning));
        return { isValid: false };
    }
}

/**
 * Legacy function for backward compatibility
 * Delegates to validateKYCTestcacheForm
 */
export function validateTestcacheForm(testcacheObject, formMode = null) {
    // Delegate to KYC validation function
    return validateKYCTestcacheForm(testcacheObject);
}


export function validateManualEntryBillingRecordForm(billingRecordObject) {

    clearMessages();
    const validateBillingProductType = reqInput(billingRecordObject.billing_type, "Billing Type");
    const validateBillingProduct = reqInput(billingRecordObject.billing_product, "Billing Product");
    const validateBillingRecordOrg = reqInput(billingRecordObject.organization, "Organization");
    const validateItemDescription = reqInput(billingRecordObject.item_description, "Item Description");
    const validateItemDescriptionNoPipe = billingRecordObject.item_description && !billingRecordObject.item_description.includes("|");
    const validateItemDescriptionNoComma = billingRecordObject.item_description && !billingRecordObject.item_description.includes(",");
    const validateItemQuantity = isInt(billingRecordObject.item_quantity, "Item Quantity");
    const validateItemUnitPrice = isFloat(billingRecordObject.item_unit_price, "Item Unit Price");

    var hasError = false;
    if (validateItemDescription && !validateItemDescriptionNoPipe) {
        message.push("Item Description cannot contain a pipe character (|).");
        warning = true;
        hasError = true;
    }

    if (validateItemDescription && !validateItemDescriptionNoComma) {
        message.push("Item Description cannot contain a comma (,).");
        warning = true;
        hasError = true;
    }

    if (validateBillingProductType && validateBillingProduct && validateBillingRecordOrg &&
        validateItemDescription && validateItemQuantity && validateItemUnitPrice) {

        if (isCountryRequired(billingRecordObject.billing_type, billingRecordObject.billing_product)) {
            const validateCountry = reqInput(billingRecordObject.country_code, "Country");
            if (!validateCountry) {
                message.push(`Country is required if you are attempting to enter an Invoice type
                 record for AVS/IDV/BV.`);
                warning = true;
                hasError = true;
            }
        }
    } else {
        hasError = true;
    }

    if (hasError) {
        store.dispatch(displayWarningMessage(message, warning));
    }

    return !hasError;
}

// Billing Group Pricing Scheme
export function validateBGPricingForm(pricingSchemeObject) {

    clearMessages();
    const validatePricingJson = isValidPricingJson(pricingSchemeObject.pricing_json);
    const validateCountry = reqInput(pricingSchemeObject.country_code, "Country");
    const validatePricingScheme = reqInput(pricingSchemeObject.pricing_scheme, "Pricing Scheme");

    if (validateCountry && validatePricingJson && validatePricingScheme) {
        return true
    } else {
        store.dispatch(displayWarningMessage(message, warning));
    }
}

export function clearMessages() {
    message = [];
    warning = false;
    store.dispatch(clearErrorMessage());
}
